"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "font-bold" };
const _hoisted_3 = { class: "mb-5" };
const _hoisted_4 = { class: "font-bold" };
const _hoisted_5 = { class: "mt-4 pt-4 border-t-1 border-gray flex justify-end" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-check" }, null, -1);
const vue_3 = require("vue");
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const FileInputBase64_vue_1 = __importDefault(require("../../components/Form/FileInputBase64.vue"));
const OrderInvoiceCreateRequest_1 = require("../../models/OrderInvoice/OrderInvoiceCreateRequest");
const TextareaInput_vue_1 = __importDefault(require("../../components/Form/TextareaInput.vue"));
const RadioOption_1 = __importDefault(require("../../components/Form/RadioGroup/RadioOption"));
const RadioGroupInput_vue_1 = __importDefault(require("../../components/Form/RadioGroup/RadioGroupInput.vue"));
const validators_1 = require("../../common/utils/validators");
const toastStore_1 = require("../../stores/toast/toastStore");
const securityStore_1 = require("../../stores/security/securityStore");
const i18n_1 = require("../../common/i18n");
const vue_router_1 = require("vue-router");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'UploadOrderInvoice',
    props: {
        openOrder: {
            type: Object,
        },
    },
    emits: ["saved"],
    setup(__props, { emit }) {
        var _a, _b, _c, _d;
        const props = __props;
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const paymentModeOptions = [
            new RadioOption_1.default(1, (_a = (0, i18n_1.trans)("cash_on_delivery", "Cash On Delivery", "upload_order_invoice")) !== null && _a !== void 0 ? _a : "Cash On Delivery", false),
            new RadioOption_1.default(2, (_b = (0, i18n_1.trans)("transfer_credit_card", "Transfer, Credit Card", "upload_order_invoice")) !== null && _b !== void 0 ? _b : "Transfer, Credit Card", false),
        ];
        const orderInvoiceCreateRequest = (0, vue_3.ref)(new OrderInvoiceCreateRequest_1.OrderInvoiceCreateRequest());
        orderInvoiceCreateRequest.value.orderId = (_d = (_c = props.openOrder) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : "";
        (0, vue_3.watchEffect)(() => {
            if (securityStore.authenticatedUser !== null) {
                orderInvoiceCreateRequest.value.uploaderEmail =
                    securityStore.authenticatedUser.email;
            }
        });
        const saveOrderInvoice = async () => {
            try {
                await (0, fetch_1.default)(router.resolve({ name: "admin_order_invoices_api" }).href, { method: "POST", body: JSON.stringify(orderInvoiceCreateRequest.value) });
                emit("saved");
                toastStore.addToast({
                    message: (0, i18n_1.trans)("order_invoice_uploaded_successfully", "Order invoice uploaded successfully!", "upload_order_invoice"),
                    type: "success",
                    timer: 5
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        return (_ctx, _cache) => {
            return (__props.openOrder !== undefined)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", null, [
                        (0, vue_2.createElementVNode)("span", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("order_id", "Order ID", "upload_order_invoice")) + ":", 1),
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.openOrder.id), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("span", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("delivery_address", "Delivery Address", "upload_order_invoice")) + ":", 1),
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(__props.openOrder.shippingName) + " " + (0, vue_2.toDisplayString)(__props.openOrder.shippingZip) + " " + (0, vue_2.toDisplayString)(__props.openOrder.shippingCity) + ", " + (0, vue_2.toDisplayString)(__props.openOrder.shippingStreet), 1)
                    ]),
                    (0, vue_2.createVNode)(FileInputBase64_vue_1.default, {
                        "base64-encode-file": orderInvoiceCreateRequest.value.base64EncodedFile,
                        "onUpdate:base64EncodeFile": _cache[0] || (_cache[0] = ($event) => ((orderInvoiceCreateRequest.value.base64EncodedFile) = $event)),
                        "original-filename": orderInvoiceCreateRequest.value.originalFilename,
                        "onUpdate:originalFilename": _cache[1] || (_cache[1] = ($event) => ((orderInvoiceCreateRequest.value.originalFilename) = $event)),
                        label: (0, vue_2.unref)(i18n_1.trans)('order_invoice_file', 'Order Invoice File (PDF, JPG, JPEG, PNG, BMP)', 'upload_order_invoice'),
                        "show-validity": true,
                        valid: !(0, vue_2.unref)(validators_1.isBlank)(orderInvoiceCreateRequest.value.base64EncodedFile),
                        "invalid-message": (0, vue_2.unref)(i18n_1.trans)('invoice_file_required', 'Invoice file required', 'invoices'),
                        accept: "image/jpg, image/jpeg, image/png, image/bmp, application/pdf",
                        placeholder: "Image",
                        class: "my-5"
                    }, null, 8, ["base64-encode-file", "original-filename", "label", "valid", "invalid-message"]),
                    (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                        placeholder: (0, vue_2.unref)(i18n_1.trans)('invoice_id_placeholder', 'Invoice ID', 'upload_order_invoice'),
                        label: (0, vue_2.unref)(i18n_1.trans)('invoice_id_label', 'Invoice ID', 'upload_order_invoice'),
                        required: "",
                        "show-validity": true,
                        valid: !(0, vue_2.unref)(validators_1.isBlank)(orderInvoiceCreateRequest.value.invoiceId),
                        "invalid-message": (0, vue_2.unref)(i18n_1.trans)('invoice_id_cant_be_empty', 'Invoice ID cant be empty', 'invoices'),
                        modelValue: orderInvoiceCreateRequest.value.invoiceId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((orderInvoiceCreateRequest.value.invoiceId) = $event)),
                        class: "my-5",
                        border: ""
                    }, null, 8, ["placeholder", "label", "valid", "invalid-message", "modelValue"]),
                    (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                        placeholder: (0, vue_2.unref)(i18n_1.trans)('gross_total_placeholder', 'Gross Total', 'upload_order_invoice'),
                        label: (0, vue_2.unref)(i18n_1.trans)('gross_total_label', 'Gross Total', 'upload_order_invoice'),
                        type: "number",
                        required: "",
                        "show-validity": true,
                        valid: orderInvoiceCreateRequest.value.isValidGrossTotal(__props.openOrder.netAmount),
                        "invalid-message": (0, vue_2.unref)(i18n_1.trans)('gross_total_not_proper_amount', 'The difference is much bigger, than the total of invoice!', 'invoices'),
                        step: 0.01,
                        modelValue: orderInvoiceCreateRequest.value.grossTotal,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((orderInvoiceCreateRequest.value.grossTotal) = $event)),
                        class: "my-5",
                        border: ""
                    }, null, 8, ["placeholder", "label", "valid", "invalid-message", "step", "modelValue"]),
                    (0, vue_2.createVNode)(RadioGroupInput_vue_1.default, {
                        modelValue: orderInvoiceCreateRequest.value.paymentMode,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((orderInvoiceCreateRequest.value.paymentMode) = $event)),
                        options: paymentModeOptions,
                        "show-validity": true,
                        valid: orderInvoiceCreateRequest.value.paymentMode !== 0,
                        "invalid-message": (0, vue_2.unref)(i18n_1.trans)('payment_mode_required', 'Payment Mode required', 'invoices'),
                        label: (0, vue_2.unref)(i18n_1.trans)('payment_mode_label', 'Payment Mode', 'upload_order_invoice')
                    }, {
                        option: (0, vue_2.withCtx)(({ option }) => [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(option.text), 1)
                        ]),
                        _: 1
                    }, 8, ["modelValue", "valid", "invalid-message", "label"]),
                    (0, vue_2.createVNode)(TextareaInput_vue_1.default, {
                        modelValue: orderInvoiceCreateRequest.value.note,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((orderInvoiceCreateRequest.value.note) = $event)),
                        label: (0, vue_2.unref)(i18n_1.trans)('note_label', 'Note', 'upload_order_invoice'),
                        "show-validity": true,
                        valid: !(0, vue_2.unref)(validators_1.isBlank)(orderInvoiceCreateRequest.value.note),
                        "invalid-message": (0, vue_2.unref)(i18n_1.trans)('note_required', 'Note required', 'invoices'),
                        class: "my-5",
                        border: ""
                    }, null, 8, ["modelValue", "label", "valid", "invalid-message"]),
                    (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                        placeholder: (0, vue_2.unref)(i18n_1.trans)('transfer_name_placeholder', 'Transfer Name', 'upload_order_invoice'),
                        label: (0, vue_2.unref)(i18n_1.trans)('transfer_name_label', 'Transfer Name', 'upload_order_invoice'),
                        required: "",
                        "show-validity": true,
                        valid: !(0, vue_2.unref)(validators_1.isBlank)(orderInvoiceCreateRequest.value.transferName),
                        "invalid-message": (0, vue_2.unref)(i18n_1.trans)('transfer_name_cant_be_empty', 'Transfer name cant be empty', 'invoices'),
                        modelValue: orderInvoiceCreateRequest.value.transferName,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((orderInvoiceCreateRequest.value.transferName) = $event)),
                        class: "my-5",
                        border: ""
                    }, null, 8, ["placeholder", "label", "valid", "invalid-message", "modelValue"]),
                    (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                        placeholder: (0, vue_2.unref)(i18n_1.trans)('transfer_phone_placeholder', 'Transfer Phone', 'upload_order_invoice'),
                        label: (0, vue_2.unref)(i18n_1.trans)('transfer_phone_label', 'Transfer Phone', 'upload_order_invoice'),
                        required: "",
                        "show-validity": true,
                        valid: !(0, vue_2.unref)(validators_1.isBlank)(orderInvoiceCreateRequest.value.transferPhone),
                        "invalid-message": (0, vue_2.unref)(i18n_1.trans)('transfer_phone_cant_be_empty', 'Transfer phone cant be empty', 'invoices'),
                        modelValue: orderInvoiceCreateRequest.value.transferPhone,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((orderInvoiceCreateRequest.value.transferPhone) = $event)),
                        class: "my-5",
                        border: ""
                    }, null, 8, ["placeholder", "label", "valid", "invalid-message", "modelValue"]),
                    (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                        placeholder: (0, vue_2.unref)(i18n_1.trans)('transfer_email_placeholder', 'Transfer Email', 'upload_order_invoice'),
                        label: (0, vue_2.unref)(i18n_1.trans)('transfer_email_label', 'Transfer Email', 'upload_order_invoice'),
                        required: "",
                        "show-validity": true,
                        valid: !(0, vue_2.unref)(validators_1.isBlank)(orderInvoiceCreateRequest.value.transferEmail) &&
                            (0, vue_2.unref)(validators_1.isValidEmail)(orderInvoiceCreateRequest.value.transferEmail),
                        "invalid-message": (0, vue_2.unref)(i18n_1.trans)('transfer_email_can_be_only_valid_email', 'Transfer email can be only valid email', 'invoices'),
                        modelValue: orderInvoiceCreateRequest.value.transferEmail,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((orderInvoiceCreateRequest.value.transferEmail) = $event)),
                        class: "my-5",
                        border: ""
                    }, null, 8, ["placeholder", "label", "valid", "invalid-message", "modelValue"]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createElementVNode)("button", {
                            disabled: !orderInvoiceCreateRequest.value.isValid(__props.openOrder.netAmount),
                            class: "btn btn-rounded btn-primary",
                            onClick: _cache[9] || (_cache[9] = ($event) => (saveOrderInvoice()))
                        }, [
                            _hoisted_7,
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("save", "Save", "upload_order_invoice")), 1)
                        ], 8, _hoisted_6)
                    ])
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
